import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../../assets/Loan/ViewLoanCollectionReceipt.css"; // Create this file
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

const DepositCollectionReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const receiptRef = useRef(null);
  const thermalReceiptRef=useRef(null)
  const data = location.state?.depoCollection;
  console.log("cusotmer", data);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  console.log("profile", profile);

  const [company, setCompany] = useState(null);

  // fetch profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
      );
      const data = await res.json();
      if (res.ok && data) {
        if (data.logo) {
          data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
        }
        if (data.qrCodeImage) {
          data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
        }
        setCompany(data);
      }
    } catch (err) {
      console.error("Error fetching company:", err);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, [profile?.superAdminId]);

  const handlePrint = async () => {
    if (!receiptRef.current) return;

    const canvas = await html2canvas(receiptRef.current, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#fff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.8);
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4", // Professional receipts usually A4 or A5
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

    // Stable Print logic
    const blobUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      window.addEventListener(
        "focus",
        () => {
          setTimeout(() => {
            if (document.body.contains(iframe))
              document.body.removeChild(iframe);
          }, 500);
        },
        { once: true },
      );
    };
  };


   const handlePrintThermalSlip = async () => {
    if (!thermalReceiptRef.current) return;

    const { jsPDF } = await import("jspdf");
    const html2canvas = (await import("html2canvas")).default;

    // 1️⃣ Render slip to canvas
    const canvas = await html2canvas(thermalReceiptRef.current, {
      scale: 3,
      backgroundColor: "#ffffff",
    });
    const imgData = canvas.toDataURL("image/png");

    // 2️⃣ Prepare PDF (thermal size)
    const pdfWidth = 58; // mm
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [pdfWidth, imgHeight],
    });
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

    // 3️⃣ Try to open print window
    try {
      const printWindow = window.open("", "_blank", "width=1000,height=600");

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Slip</title>
            <style>
              @page { size: 58mm auto; margin:0; }
              body { margin:0; padding:0; text-align:center; }
              img { width:58mm; max-width:58mm; }
            </style>
          </head>
          <body>
            <img src="${imgData}" />
          </body>
        </html>
      `);

      printWindow.document.close();

      // Wait for print window to load
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        // Optional: close after printing
        setTimeout(() => printWindow.close(), 500);
      };
    } catch (err) {
      // 4️⃣ Fallback → Download PDF
      pdf.save(`LoanSlip_${data.customerName || "Customer"}.pdf`);
    }
  };

  if (!data) {
    return <div className="p-10 text-center">Receipt Data Not Found</div>;
  }

  return (
    <div className="receipt-viewer-container">
      {/* Action Buttons */}
      <div className="receipt-actions receipt-no-print">
        <button onClick={() => navigate(-1)} className="receipt-back-btn">
          Back
        </button>
        <button onClick={handlePrint} className="btn-print-receipt">
          Print Receipt
        </button>
        <button onClick={()=>{
            handlePrintThermalSlip() 
        }
        }className="btn-thermal-print-receipt">
          Thermal Print Receipt
        </button>
      </div>

      {/* Printable Receipt Design */}
      <div className="receipt-paper" ref={receiptRef}>
        <div className="receipt-header-section">
          <div className="receipt-header-company-section">
            <div className="receipt-company-details">
              <img src={company?.logoUrl} alt="logo" className="receipt-logo" />
              <div className="receipt-header-company-info">
                <h1>{company?.name || "N/A"}</h1>
                <p className="address">
                  <b>Address: </b>
                  {company?.address || "N/A"}
                </p>
                <p className="contact">
                  <b>Phone:</b> {company?.contact || "N/A"} | <b>Email:</b>{" "}
                  {company?.email || "N/A"}
                </p>
                <p className="cin">
                  <b>CIN:</b> {company?.cin || "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="receipt-title-box">
            <h2>DEPOSIT COLLECTION RECEIPT</h2>
            <p>
              Receipt No: #{data.receiptNo || data.id} | Date:{" "}
              {new Date(Date.now()).toLocaleDateString(
                "en-GB",
              )||data.createdAt }
            </p>
          </div>
        </div>

        {/* Sections */}
        <div className="receipt-section">
          <h3 className="receipt-section-title">Deposite Collectios Details</h3>
          <div className="receipt-details-wrapper">
            <div className="receipt-grid-item">
              <span>Customer Name:</span> <strong>{data.account.customerName || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Customer ID:</span> <strong>{data.customerId|| "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Account Number:</span>{" "}
              <strong>{data.account.accountNo || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Account Type:</span>{" "}
              <strong>{data.account.accountType || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Amount:</span>{" "}
              <strong>{"₹"+data.amount || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Principal Amount:</span>{" "}
              <strong>{"₹"+data.principalPart || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Interest:</span>{" "}
              <strong>{"₹"+data.interestPart||0}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Installment No:</span>{" "}
              <strong>{data.installmentNo || "N/A"}</strong>
            </div>
            
            <div className="receipt-grid-item">
              <span>Due Date:</span>{" "}
              <strong>
                {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
              </strong>
            </div>
            <div className="receipt-grid-item">
              <span>Collection Date:</span>{" "}
              <strong>
                {new Date(data.collectionDate).toLocaleDateString("en-GB") ||
                  "N/A"}
              </strong>
            </div>
            <div className="receipt-grid-item">
              <span>Collection Type:</span>{" "}
              <strong>{data.collectionType || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Status:</span>{" "}
              <strong>{data.status.toUpperCase() || "N/A"}</strong>
            </div>
          </div>
        </div>

        {/* <table className="receipt-outstanding-table">
          <tr className="receipt-outstanding-row">
            <td>Outstanding Amount</td>
            <td>
              ₹{" "}
              {Number(data.outstanding).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
              })}
            </td>
          </tr>
        </table> */}


        <div className="receipt-footer-signs">
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Authorized Signatory</p>
          </div>
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Customer Signature</p>
          </div>
        </div>

        <p className="receipt-system-gen-text">
          This is a system-generated slip and does not require a signature.
          <br />
          For any queries, please contact us during business hours.
        </p>
      </div>

      

{/* Thermal print design */}
      <div className="thermal-slip-wrapper">
  <div ref={thermalReceiptRef} className="thermal-slip">
    
    {/* COMPANY INFO */}
    <div className="thermal-company">
      <div className="thermal-company-name">
        {company ? company.name : "--"}
      </div>
      <div className="thermal-company-text">
        <b>Address:</b> {company ? company.address : "--"}
      </div>
      <div className="thermal-company-text">
        <b>Phone:</b> {company ? company.contact : "--"} | <b>Email:</b> {company ? company.email : "--"}
      </div>
      <div className="thermal-company-text">
        <b>CIN:</b> {company ? company.cin : "--"}
      </div>
      
    </div>

    {/* TITLE */}
    <div className="thermal-title">
      Deposit Collection Receipt
    </div>

    <div className="thermal-divider"></div>

    {/* DETAILS */}
    <div className="thermal-row">
      <b>Customer Name:</b> {data?.account?.customerName || "--"}
    </div>
    <div className="thermal-row">
      <b>Customer ID:</b> {data?.customerId || "--"}
    </div>
    <div className="thermal-row">
      <b>Account Number:</b> {data?.account?.accountNo || "--"}
    </div>
    <div className="thermal-row">
      <b>Account Type:</b> {data?.account?.accountType || "--"}
    </div>
    <div className="thermal-row">
      <b>Amount:</b> {"₹"+data?.amount || "--"}
    </div>
    <div className="thermal-row">
      <b>Principal Amount:</b>{"₹"+data?.principalPart || "--"}
    </div>
    <div className="thermal-row">
      <b>Interest:</b> {"₹"+data?.interestPart || 0}
    </div>
    <div className="thermal-row">
      <b>Installment No:</b> {data?.installmentNo || "N/A"}
    </div>
    <div className="thermal-row">
      <b>Due Date:</b> {new Date(data.dueDate).toLocaleDateString("en-GB") || "N/A"}
    </div>
    <div className="thermal-row">
      <b>Collection Date:</b> {new Date(data.collectionDate).toLocaleDateString("en-GB") ||
                  "N/A"}
    </div>
    <div className="thermal-row">
      <b>Collection Type:</b> {data?.collectionType || "--"}
    </div>
    <div className="thermal-row">
      <b>Status:</b> {data?.status || "--"}
    </div>

    <div className="thermal-divider"></div>

    {/* FOOTER */}
    <div className="thermal-footer">
      <div>Thank you for your payment!</div>
      <div>
       Computer Generated Receipt
      </div>
    </div>
  </div>
</div>
    </div>
  );
};

export default DepositCollectionReceipt;
